export const milkingSlots = [
    { type: "morning", label: "Πρωινή" },
    { type: "noon", label: "Μεσημεριανή" },
    { type: "evening", label: "Βραδινή" },
];

export const isMeasuredMilking = (check) => check?.checked === true
    || (check?.checked == null && Boolean(check?.time));

export const getMilkingChecks = (values) => milkingSlots.map(({ type }) => ({
    type,
    time: values[`${type}MilkingTime`] || null,
    checked: values[`${type}MilkingTypeCheck`] === true,
}));

export const formatMilkingTime = (time) => new Intl.DateTimeFormat("el-GR", {
    timeZone: "Europe/Athens",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
}).format(new Date(time));

export const validateMilkingSchedule = (checks) => {
    const measured = checks.filter((check) => check.checked);
    if (measured.length === 0) return "Επιλέξτε τουλάχιστον μία άμελξη που μετρήθηκε στον έλεγχο.";
    if (measured.some((check) => !check.time)) return "Συμπληρώστε την ώρα κάθε άμελξης που μετρήθηκε.";
    const scheduled = checks.filter((check) => check.time);
    if (scheduled.some((check) => Number.isNaN(new Date(check.time).getTime()))) {
        return "Συμπληρώστε έγκυρες ώρες για όλες τις καθημερινές αμέλξεις.";
    }
    if (scheduled.length < 2 || scheduled.length > 3) {
        return "Συμπληρώστε τις ώρες όλων των καθημερινών αμέλξεων της εκτροφής (2 ή 3), ακόμη και όσων δεν μετρήθηκαν.";
    }
    const times = scheduled.map((check) => formatMilkingTime(check.time));
    if (times.some((time, index) => index > 0 && time <= times[index - 1])) {
        return "Οι ώρες πρέπει να έχουν σειρά πρωί, μεσημέρι και βράδυ, χωρίς διπλότυπα.";
    }
    return null;
};
